<template>
  <div ref="mainFormGenerator">
    <FormVeeGenerator ref="observer" class="form-generator-container" tag="div">
      <form @submit.prevent="emitData()">
        <div v-if="loaded" class="form-generator">
          <FormGeneratorComponent v-for="field in formConfigFormatted" :key="field.uniqId" ref="formGeneratorComponent"
            :formConfig="field" :formData="formData" :checkBoxUniq="checkBoxUniq"
            :checkboxChildrenValue="checkboxChildrenMain" :lastIndex="Object.keys(lastIndex).length > 0 && lastIndex[field.name]
        ? lastIndex[field.name]
        : Object.keys(lastIndex).length > 0
          ? lastIndex
          : 0
        " @add-data="addData($event.name, $event.value, $event.duplicate, $event.duplicateElement)"
            @add="duplicateBlock(formConfig, $event.name, $event.duplicateIndex)"
            @delete="deleteDuplicateBlock(formConfig, $event.name, $event.duplicateIndex)"
            @clear="clearDuplicateBlock(formConfig, $event.name, $event.duplicateIndex)"
            @set-default="setDefaultDuplicateBlock(formConfig, $event.name, $event.duplicateIndex)"
            @add-element="duplicateElement(formConfig, $event.name, $event.duplicateElementIndex)"
            @delete-element="deleteDuplicateElement(formConfig, $event.name, $event.duplicateElementIndex)"
            @only-one-selected-name="setCheckBoxUniq($event)"
            @check-box-children-show="checkBoxChildrenShowCheck($event)" />
        </div>
        <div class="form-generator-bottom">
          <button v-if="clearButton" style="user-select: none" class="form-generator-button btn-custom clear-btn"
            type="button" @click="clearAllFields($refs.formGeneratorComponent)">
            {{ $t('form.clearAllFields') }}
          </button>
          <button v-if="displayButton" :disabled="buttonDisable && errorsForDisabled > 0" style="user-select: none"
            class="form-generator-button btn-custom" type="submit">
            {{ $t('form.' + buttonText) }}
          </button>
        </div>
      </form>
    </FormVeeGenerator>
    <Modal v-if="validationFormModalOpen" :showCloseButton="false" :title="$t('pendingBasketList.warningModalTitle')">
      <template #body>
        <div class="validation-form-modal">
          <p class="validation-form-modal-subtitle">
            {{ $t('customer.validationFormModal.subtitle') }}
          </p>
          <div v-for="(error, i) in validationErrors" :key="i" class="errors-container">
            <p v-if="error.translate">
              <span class="text-bold">{{ $t(`form.${error.field}`) }}</span>: {{ $t(`errors.${error.message}`) }}
            </p>
            <p v-else>
              <span class="text-bold">{{ $t(`form.${error.field}`) }}</span>: {{ error.message }}
            </p>
          </div>
          <div class="actions">
            <button class="btn-custom-modal" @click="validationFormModalOpen = false">
              {{ $t('customer.validationFormModal.modifyData') }}
            </button>
            <button v-if="checkErrorCapency(validationErrors)" class="btn-custom-modal-outline" @click="emitData()">
              {{ $t('customer.validationFormModal.continueWithForcedData') }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Form as FormVeeGenerator } from 'vee-validate'
import FormGeneratorComponent from '@/components/GenericComponents/FormGeneratorComponent.vue'
import Modal from '@/components/GenericComponents/Modal.vue'
import _ from 'lodash'
import { autoCompleteService } from '@/services/autocomplete.service'
import { appConfigurationStore } from '@/stores/appConfigurationStore.js'

import '@/components/GenericComponents/Form/ValidationRules/birthdate.js'
import '@/components/GenericComponents/Form/ValidationRules/standard_rules.js'
import '@/components/GenericComponents/Form/ValidationRules/required_without_all_set_or_true.js'
import '@/components/GenericComponents/Form/ValidationRules/bool.js'
import '@/components/GenericComponents/Form/ValidationRules/date_between.js'
import '@/components/GenericComponents/Form/ValidationRules/mailunique.js'
import '@/components/GenericComponents/Form/ValidationRules/alpha_spaces_dash.js'
import '@/components/GenericComponents/Form/ValidationRules/zip_code.js'
import '@/components/GenericComponents/Form/ValidationRules/required_with_any.js'
import '@/components/GenericComponents/Form/ValidationRules/required_without_one.js'
import '@/components/GenericComponents/Form/ValidationRules/required_without_any.js'
import '@/components/GenericComponents/Form/ValidationRules/checkValidPhoneNumber.js'
import '@/components/GenericComponents/Form/ValidationRules/number_must_be_over_min_number.js'
import '@/components/GenericComponents/Form/ValidationRules/canSelectIfSetOrTrue.js'
import '@/components/GenericComponents/Form/ValidationRules/checkValidMobilePhoneNumber.js'
import '@/components/GenericComponents/Form/ValidationRules/fillableIfFieldIsSet.js'
import '@/components/GenericComponents/Form/ValidationRules/phoneNumberWithoutCountryCode.js'
import { EventBus } from '@/event-bus'

export default {
  name: 'FormGenerator',
  components: {
    FormVeeGenerator,
    FormGeneratorComponent,
    Modal
  },
  props: {
    /**
     * Index for the module in the configuration
     * (e.g. : customers, products, etc...)
     */
    formModel: String,
    /**
     * Index inside the module index in the configuration
     * (e.g. : customers: {create_update: {...}}
     */
    formAction: String,
    /**
     * Data object to fill in form elements with values
     * e.g. : In the FormGenerator parent component data :
     * formData: {
     *   firstname_customer: 'Marcelle',
     *   lastname_customer: 'Daigle'
     * }
     */
    formData: {
      type: Object,
      default: () => { }
    },
    buttonContent: String,
    buttonDisable: {
      type: Boolean,
      default: false
    },
    displayButton: {
      type: Boolean,
      default: true
    },
    displayLabel: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isDisplayErrorPhone: {
      type: Boolean,
      default: false
    },
    //Emit data before validate
    emitTempData: {
      type: Boolean,
      default: false
    },
    clearButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['form-data', 'emitTempData'],
  data() {
    return {
      /**
       * Get the configuration in the store at the formModel and formAction indexes
       */
      buttonText: this.buttonContent || 'validate',
      formConfig: null,
      currentData: {},
      lastIndex: {},
      checkBoxUniq: {},
      checkboxChildrenMain: {},
      errorsForDisabled: null,
      loaded: false,
      validationFormModalOpen: false,
      validationErrors: []
    }
  },
  computed: {
    formConfigFormatted() {
      if (!this.formConfig) {
        return []
      }
      return this.formatFormConfig(JSON.parse(JSON.stringify(this.formConfig)))
    }
  },
  mounted() {
    // If formAction index was not found in the configuration
    if (!appConfigurationStore().appConfiguration.parameters[this.formModel][this.formAction]) {
      console.error(this.formAction + ' was not found in the API configuration.')
      this.$router.push({
        name: 'ErrorPage',
        query: {
          statusCode: '500',
          errorMsg:
            'An error occured while creating your client account.'
        },
        params: { pathMatch: 'errorCreate' }
      })
    } else {
      this.formConfig = JSON.parse(
        JSON.stringify(appConfigurationStore().appConfiguration.parameters[this.formModel][this.formAction])
      )

      if (this.buttonDisable) {
        this.setErrorsForDisabled()
      }
      this.createDuplicate(this.formConfig)
      this.uniqIdRecursive(this.formConfig)
    }
    this.loaded = true
  },
  methods: {
    /**
     * Set name and main name for uniq checkbox
     * @param {Array} event
     */
    setCheckBoxUniq(event) {
      this.checkBoxUniq[event.mainName] = event.name
    },
    uniqIdRecursive(formConfig) {
      for (const key in formConfig) {
        formConfig[key].uniqId = _.uniqueId(formConfig[key].name)
        if (formConfig[key].children) {
          this.uniqIdRecursive(formConfig[key].children)
        }
      }
    },
    /**
     * Format computed formConfig
     * ...(condition && {value})
     * @param {Array} formConfigs
     * @param {String} path filter formData by path for default value
     * @param {String} multipleIndex key for duplicate components
     * @returns {Array} formConfigs
     */
    formatFormConfig(formConfigs, path = null, duplicateIndex = null) {
      for (const formConfig of formConfigs) {
        let isReadOnly = this.isReadOnly
        if (formConfig.readOnly) {
          isReadOnly = isReadOnly || formConfig.readOnly
        }
        const formatConfig = {
          ...(formConfig.label && { label: this.$t('form.' + formConfig.label) }),
          ...(formConfig.placeholder && { placeholder: this.$t('form.' + formConfig.placeholder) }),
          //Set default value from config
          ...(formConfig.default_value && { defaultValue: formConfig.default_value }),
          //Override default value with formdata
          ...(this.formData &&
            this.recursiveFormData(
              path ? this.findDataChildren(this.formData, path) : this.formData,
              formConfig.name,
              true,
              duplicateIndex,
              formConfig.duplicateElementIndex
            ) && {
            defaultValue: this.recursiveFormData(
              path ? this.findDataChildren(this.formData, path) : this.formData,
              formConfig.name,
              false,
              duplicateIndex,
              formConfig.duplicateElementIndex
            )
          }),
          //Override default value with currentData
          ...(this.currentData &&
            this.recursiveFormData(
              path ? this.findDataChildren(this.currentData, path) : this.currentData,
              formConfig.name,
              true,
              duplicateIndex,
              formConfig.duplicateElementIndex
            ) && {
            defaultValue: this.recursiveFormData(
              path ? this.findDataChildren(this.currentData, path) : this.currentData,
              formConfig.name,
              false,
              duplicateIndex,
              formConfig.duplicateElementIndex
            )
          }),
          ...(formConfig.validation &&
            this.getValidationValue(formConfig.validation, 'min') && {
            min: this.getValidationValue(formConfig.validation, 'min')
          }),
          ...(formConfig.validation &&
            this.getValidationValue(formConfig.validation, 'max') && {
            max: this.getValidationValue(formConfig.validation, 'max')
          }),
          ...(!formConfig.validation && { validation: '' }),
          ...(formConfig.validation_second && { validationSecond: formConfig.validation_second }),
          ...(this.getValidationValue && { getValidationValue: this.getValidationValue }),
          ...(formConfig.options && { dataOptions: formConfig.options }),
          ...{ translate: formConfig.translate ? formConfig.translate : false },
          ...(formConfig.class && { className: formConfig.class }),
          ...{ formAction: this.formAction },
          ...((this.displayLabel || formConfig.displayLabel) && {
            displayLabel: this.displayLabel || formConfig.displayLabel
          }),
          ...{ isReadOnly: isReadOnly },
          ...{ isDisplayErrorPhone: this.isDisplayErrorPhone },
          ...(this.getChildByName && { getChildByName: this.getChildByName }),
          ...(this.setAutocomplete && { setAutocomplete: this.setAutocomplete })
        }
        Object.assign(formConfig, formatConfig)
        if (formConfig.children) {
          this.formatFormConfig(formConfig.children, formConfig.name, formConfig.duplicateIndex)
        } else if (formConfig.fields) {
          this.formatFormConfig(formConfig.fields, formConfig.name, formConfig.duplicateIndex)
        }
      }
      return formConfigs
    },
    /**
     * filter formData by path for default value
     * @param {Object} formData default values
     * @param {String} path
     * @returns {Array} formData
     */
    findDataChildren(formData, path) {
      if (path && formData[path]) {
        return formData[path]
      }
      return formData
    },
    /**
     * Create duplicate with default values from formData
     * @param {Object} formConfig
     */
    createDuplicate(formConfig) {
      let duplicateData = null
      for (const key in formConfig) {
        if (formConfig[key].duplicate) {
          formConfig[key].duplicateIndex = 0
          duplicateData = formConfig[key]
        } else if (formConfig[key].duplicate_element) {
          formConfig[key].duplicateElementIndex = 0
          duplicateData = formConfig[key]
        }

        if (duplicateData && this.formData && this.formData[duplicateData.name]) {
          this.lastIndex = {
            [duplicateData.name]:
              this.formData[duplicateData.name].length - 1 <= 0 ? 0 : this.formData[duplicateData.name].length - 1
          }
          for (let index = 0; index < this.formData[duplicateData.name].length - 1; index++) {
            if (formConfig[key].duplicate) {
              formConfig.splice(key + 1, 0, { ...duplicateData, ...{ duplicateIndex: index + 1 } })
            } else if (formConfig[key].duplicate_element) {
              formConfig.splice(key + 1, 0, { ...duplicateData, ...{ duplicateElementIndex: index + 1 } })
            }
          }
        } else if (formConfig[key].children) {
          this.createDuplicate(formConfig[key].children)
        }
      }
    },
    /**
     * Set data from form
     * @param {String} name name of key
     * @param {String | Object} value
     * @param {String} duplicate optional tranform/set to array if duplicate block
     * @param {String} duplicateElement optional tranform/set to array if duplicate element
     */
    async addData(name, value, duplicate = null, duplicateElement = null) {
      if (duplicate !== null) {
        if (!this.currentData[name]) {
          this.currentData[name] = []
        }
        if (!this.currentData[name][duplicate]) {
          this.currentData[name][duplicate] = {}
        }
        this.currentData[name][duplicate][Object.keys(value)[0]] = Object.values(value)[0]
      } else if (duplicateElement !== null) {
        if (!this.currentData[name]) {
          this.currentData[name] = {}
        }
        if (!this.currentData[name][duplicateElement.name]) {
          this.currentData[name][duplicateElement.name] = []
        }
        this.currentData[name][duplicateElement.name][duplicateElement.index] = Object.values(value)[0]
      } else if (this.currentData[name]) {
        this.currentData = this.mergeDeep(this.currentData, { [name]: value })
      } else {
        this.currentData[name] = value
      }
      if (this.emitTempData) {
        this.$emit('emitTempData', this.currentData)
      }
      if (this.buttonDisable) {
        this.setErrorsForDisabled()
      }
    },
    async setErrorsForDisabled() {
      const isValid = await this.$refs.observer.validate({ silent: true })
      this.errorsForDisabled = Object.keys(isValid.errors).length
    },
    /**
     * Foreach formdata for find default value
     * @param {Array} formData default values
     * @param {String} name name(id) to find
     * @param {Boolean} validation
     * @return {String | Boolean | Null}
     */
    recursiveFormData(formData, name, validation = false, duplicateIndex = null, duplicateElementIndex = null) {
      if (
        duplicateIndex !== null &&
        Array.isArray(formData) &&
        formData[duplicateIndex] &&
        formData[duplicateIndex][name]
      ) {
        return validation ? true : formData[duplicateIndex][name]
      } else if (duplicateIndex !== null && Array.isArray(formData) && !formData[duplicateIndex]) {
        return validation ? false : null
      } else if (duplicateElementIndex !== null && formData[name] && formData[name][duplicateElementIndex]) {
        return validation ? true : formData[name][duplicateElementIndex]
      } else if (duplicateElementIndex !== null && formData[name] && !formData[name][duplicateElementIndex]) {
        return validation ? false : null
      }
      for (const key in formData) {
        if (key === name) {
          return validation && formData[key] !== '' ? true : formData[key]
        }
        if (Array.isArray(formData[key])) {
          if (duplicateIndex !== null && duplicateIndex === key) {
            return validation ? true : formData[key]
          } else {
            for (const valKey in formData[key]) {
              if (formData?.[key]?.[valKey]?.[name]) {
                return validation ? true : formData[key][valKey][name]
              }
            }
          }
        } else if (this.isObject(formData[key])) {
          const checkObject = this.recursiveFormData(
            formData[key],
            name,
            validation,
            duplicateIndex,
            duplicateElementIndex
          )
          if (checkObject) return checkObject
        }
      }
      return validation ? false : null
    },
    /**
     * Simple object check.
     * @param {?Object} item
     * @returns {boolean}
     */
    isObject(item) {
      return item && typeof item === 'object' && !Array.isArray(item)
    },
    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    mergeDeep(target, ...sources) {
      if (!sources.length) return target
      const source = sources.shift()
      if (this.isObject(target) && this.isObject(source)) {
        for (const key in source) {
          if (this.isObject(source[key])) {
            if (!target[key]) Object.assign(target, { [key]: {} })
            this.mergeDeep(target[key], source[key])
          } else {
            Object.assign(target, { [key]: source[key] })
          }
        }
      }
      return this.mergeDeep(target, ...sources)
    },
    /**
     * Send an Emit with the form results
     */
    async emitData() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid.valid) {
        EventBus.emit('showBanner', {
          type: 'danger',
          message: `${Object.keys(isValid.errors).length} ${Object.keys(isValid.errors).length > 1 ? this.$t('form.invalidFields') : this.$t('form.invalidField')
            }`
        })
      } else {
        localStorage.removeItem('email')
        document.activeElement.blur()
        // Send the form data to the parent
        if (
          (this.$appConfigurationStore.appConfiguration?.modules?.general?.autocomplete?.validation?.enabled ?? false) &&
          this.formModel === 'customers' &&
          (this.formAction === 'create' || this.formAction === 'update') &&
          this.validationFormModalOpen === false
        ) {
          let result = await autoCompleteService.validateAutocompletedValues(this.currentData)

          if (result.validated === true || Object.keys(result)[0] != 'validated') {
            this.$emit('form-data', this.currentData)
          } else {
            this.validationFormModalOpen = true
            this.validationErrors = result.errors
            return
          }
        } else {
          this.validationFormModalOpen = false
          this.validationErrors = []
          this.$emit('form-data', this.currentData)
        }
      }
    },
    /**
     * Duplicate block (multiple form input block children)
     * @param {Object} config
     * @param {String} name
     * @param {Number} duplicateIndex
     */
    duplicateBlock(config, name, duplicateIndex) {
      for (const key in config) {
        if (config[key].name && config[key].name === name) {
          const addIndex = { ...config[key] }
          addIndex.duplicateIndex = duplicateIndex + 1
          addIndex.uniqId = _.uniqueId(config[key].name)
          this.formConfig.splice(Number(this.findLastIndex(this.formConfig, 'name', name)) + 1, 0, addIndex)
          if (duplicateIndex === 0) {
            this.lastIndex[name] = 1
          } else {
            this.lastIndex[name] = this.lastIndex[name] + 1
          }
          break
        } else if (config[key].children) {
          this.duplicateBlock(config[key].children, name, duplicateIndex)
        }
      }
    },
    /**
     * Delete duplicate block (multiple form input block children)
     * @param {Object} config formConfig data
     * @param {String} name
     * @param {Number} duplicateIndex
     */
    deleteDuplicateBlock(config, name, duplicateIndex) {
      for (const key in config) {
        if (config[key].duplicateIndex === duplicateIndex) {
          this.formConfig.splice(Number(key), 1)
          this.currentData[name].splice(duplicateIndex, 1)
          this.lastIndex[name] = this.lastIndex[name] - 1
          for (const keySub in this.formConfig) {
            if (this.formConfig[keySub].duplicateIndex && this.formConfig[keySub].duplicateIndex > duplicateIndex) {
              this.formConfig[keySub].duplicateIndex = this.formConfig[keySub].duplicateIndex - 1
            }
          }
          break
        } else if (config[key].children) {
          this.deleteDuplicateBlock(config[key].children, name, duplicateIndex)
        }
      }
    },
    /**
     * Clear duplicate block (multiple form input block children)
     * @param {Object} config formConfig data
     * @param {String} name
     * @param {Number} duplicateIndex
     */
    clearDuplicateBlock(config, name, duplicateIndex) {
      this.currentData[name].splice(duplicateIndex, 1)
      for (const key in this.formConfig) {
        if (this.formConfig[key].name === name) {
          delete this.formConfig[key].children
          //refresh computed
          this.formConfig[key].enabled = !this.formConfig[key].enabled
          this.formConfig[key].enabled = !this.formConfig[key].enabled
        }
      }
      this.lastIndex[name] = -1
    },
    /**
     * Set back defalt duplicate block (multiple form input block children)
     * @param {Object} config formConfig data
     * @param {String} name
     */
    setDefaultDuplicateBlock(config, name) {
      for (const key in this.formConfig) {
        if (this.formConfig[key].name === name) {
          this.formConfig[key].children =
            this.$appConfigurationStore?.appConfiguration.parameters[this.formModel][this.formAction][key].children
          //refresh computed
          this.formConfig[key].enabled = !this.formConfig[key].enabled
          this.formConfig[key].enabled = !this.formConfig[key].enabled
        }
      }
      this.lastIndex[name] = 0
    },
    /**
     * Duplicate form element
     * @param {Object} config formConfig data
     * @param {String} name
     * @param {Number} duplicateElementIndex
     */
    duplicateElement(config, name, duplicateElementIndex, indexKey = null) {
      for (const key in config) {
        if (config[key].name && config[key].name === name) {
          const addIndex = { ...config[key] }
          addIndex.uniqId = _.uniqueId(config[key].name)
          addIndex.duplicateElementIndex = duplicateElementIndex + 1
          if (indexKey !== null) {
            this.formConfig[indexKey].children.splice(
              Number(this.findLastIndex(this.formConfig[indexKey].children, 'name', name)) + 1,
              0,
              addIndex
            )
          } else {
            this.formConfig.splice(Number(this.findLastIndex(this.formConfig, 'name', name)) + 1, 0, addIndex)
          }

          if (duplicateElementIndex === 0) {
            this.lastIndex[name] = 1
          } else {
            this.lastIndex[name] = this.lastIndex[name] + 1
          }
          break
        } else if (config[key].children) {
          this.duplicateElement(config[key].children, name, duplicateElementIndex, Number(key))
        }
      }
    },
    /**
     * Delete form element
     * @param {Object} config formConfig data
     * @param {String} name
     * @param {Number} duplicateElementIndex
     */
    deleteDuplicateElement(config, name, duplicateElementIndex, indexKey = null, parent = null) {
      for (const key in config) {
        if (config[key].duplicateElementIndex === duplicateElementIndex && config[key].name === name) {
          if (parent) {
            this.currentData[parent][name].splice(duplicateElementIndex, 1)
          } else {
            this.currentData[name].splice(duplicateElementIndex, 1)
          }
          this.lastIndex[config[key].name] = this.lastIndex[config[key].name] - 1
          if (indexKey !== null) {
            for (const keyChildren in this.formConfig[indexKey].children) {
              if (
                this.formConfig[indexKey].children[keyChildren].duplicateElementIndex === duplicateElementIndex &&
                this.formConfig[indexKey].children[keyChildren].name === name
              ) {
                this.formConfig[indexKey].children.splice(Number(keyChildren), 1)
              }
            }
          } else {
            this.formConfig.splice(Number(key), 1)
          }
          for (const keySub in this.formConfig) {
            if (
              this.formConfig[keySub].duplicateElementIndex &&
              this.formConfig[keySub].duplicateElementIndex > duplicateElementIndex
            ) {
              this.formConfig[keySub].duplicateElementIndex = this.formConfig[keySub].duplicateElementIndex - 1
            } else if (indexKey !== null) {
              for (const keyChildrenSub in this.formConfig[keySub].children) {
                if (
                  this.formConfig[keySub].children[keyChildrenSub].duplicateElementIndex &&
                  this.formConfig[keySub].children[keyChildrenSub].duplicateElementIndex > duplicateElementIndex &&
                  this.formConfig[indexKey].children[keyChildrenSub].name === name
                ) {
                  this.formConfig[keySub].children[keyChildrenSub].duplicateElementIndex =
                    this.formConfig[keySub].children[keyChildrenSub].duplicateElementIndex - 1
                }
              }
            }
          }
          break
        } else if (config[key].children) {
          this.deleteDuplicateElement(
            config[key].children,
            name,
            duplicateElementIndex,
            Number(key),
            config[key].name
          )
        }
      }
    },
    /**
     * Find last index of array by key name
     * @param {Array} array
     * @param {String} searchKey
     * @param {String} searchValue
     */
    findLastIndex(array, searchKey, searchValue) {
      const index = array
        .slice()
        .reverse()
        .findIndex(x => x[searchKey] === searchValue)
      const count = array.length - 1
      const finalIndex = index >= 0 ? count - index : index
      return finalIndex
    },
    /**
     * Set checkbox children data
     * @param {Object} event
     */
    checkBoxChildrenShowCheck({ name, value }) {
      this.checkboxChildrenMain[name] = value
    },
    /**
     * Autocomplete
     * @param {String} values
     * @param {String} field
     */
    setAutocomplete(values, field) {
      EventBus.emit('changeAutocomplete' + field, values)
    },
    /**
     * GET THE VAR NEEDED FROM THE VALIDATION e.g.: MIN & MAX
     * @param {String} validation : validation index in the form configuration
     * @param {String} value : value that is searched in the validation (e.g. : min, max, etc...)
     */
    getValidationValue(validation, value) {
      let tab = validation.split('|')
      for (let el of tab) {
        if (el.includes(value)) {
          return el.split(':')[1] ? el.split(':')[1] : true
        }
      }
    },
    /**
     * Find value form object by name recursive
     * @param {String} name
     * @return {String}
     */
    getChildByName(name) {
      return this.findVal(this.currentData, name)
    },
    /**
     * Find value form object by name
     * @param {Object} object
     * @param {String} key
     * @return {String}
     */
    findVal(object, key) {
      let value
      Object.keys(object).some(k => {
        if (k === key && typeof object[k] !== 'object') {
          value = object[k]
          return true
        }
        if (object[k] && typeof object[k] === 'object') {
          value = this.findVal(object[k], key)
          return value !== undefined
        }
      })
      return value
    },
    clearAllFields(refs) {
      for (let comp of refs) {
        if ('clearInput' in comp.$refs.formGeneratorField) {
          comp.$refs.formGeneratorField.clearInput()
        }

        if ('clearCodeCountry' in comp.$refs.formGeneratorField) {
          comp.$refs.formGeneratorField.clearCodeCountry()
        }

        if (comp.$refs?.formGeneratorComponent) {
          this.clearAllFields(comp.$refs.formGeneratorComponent)
        }
      }
    },
    checkErrorCapency(errors) {
      for (const error of errors) {
        if (['40001', '4004X'].includes(error.error_id)) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.form-generator-container {

  /* Landscape screens */
  @media only screen and (orientation: landscape) {
    max-width: 1000px;
    margin: auto;
  }

  .form-generator {
    display: flex;
    flex-direction: column;
    padding: 1rem;
  }
}

.form-generator-bottom {

  /* Landscape screens */
  @media only screen and (orientation: landscape) {
    max-width: 1000px;
    margin: auto;
  }

  button:disabled {
    background-color: #ddd;
  }
}

.validation-form-modal-subtitle {
  margin: 0.5em 0.5em 1em;
}

.errors-container {
  margin: 0.5em;
}
</style>

<style lang="scss" scoped>
.form-generator-bottom {
  .clear-btn {
    background-color: rgba(var(--primary-color));
    border: 1px solid black;
    color: black;
  }
}

.btn-custom-modal,
.btn-custom-modal-outline {
  margin: 0.5em !important;
}
</style>
